document.addEventListener('DOMContentLoaded', function(event) {
  var allSwatches = document.querySelectorAll('.color-swatches .color-item');
  var videoChange = document.querySelector('#video-change');

  function setVideoActive(active) {
    allSwatches.forEach(function(item, index) {
        if (index == active - 1) {
              item.classList.add('active');
        } else {
              item.classList.remove('active');
        }
    });
  }

  allSwatches.forEach(function(item, index) {
    item.addEventListener('click', function(event) {
      if (!item.classList.contains('active')) {
        event.preventDefault();
        videoChange.innerHTML = "";
        var newVideo = document.createElement('video');
        var setControlsVideo = videoChange.querySelector('video');
        newVideo.setAttribute('src', item.dataset.video);
        newVideo.setAttribute('playsinline', 'playsinline');
        newVideo.setAttribute('autoplay', 'autoplay');
        newVideo.setAttribute('loop', 'loop');
        newVideo.setAttribute('muted', 'muted');
        videoChange.appendChild(newVideo);
        setVideoActive(parseInt(item.dataset.index));
      } 
    });
  });

})